import { createSlice } from "@reduxjs/toolkit";

export const AdminDashboardData = createSlice({
  name: "AdminDashboardData",
  initialState: {
    sessionStudentUploadData: [] as any[],
  },
  reducers: {
    setSessionStudentUploadData: (state, action) => {
      state.sessionStudentUploadData = action.payload;
    },
  },
});

export const { setSessionStudentUploadData } = AdminDashboardData.actions;

export default AdminDashboardData.reducer;
